import React from 'react';
import PropTypes from 'prop-types';
import DefaultFallback from './DefaultFallback/DefaultFallback.component';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log({ error }); // eslint-disable-line no-console
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo); // eslint-disable-line no-console
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    const { fallBackComponent } = this.props;
    const { message } = this.props;

    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <h2 style={{margin:'0', paddingBottom:'0', textAlign:'center'}}>Something went wrong.</h2>
          {fallBackComponent}
          {!fallBackComponent && <DefaultFallback message={message} />}
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.defaultProps = {
  fallBackComponent: null,
};

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string.isRequired,
  fallBackComponent: PropTypes.element,
};

export default ErrorBoundary;
